<template>
  <div class="check-availability">
    <c-button
      :is-disabled="checkingAvailability"
      :is-loading="checkingAvailability"
      :loading-text="$t('shoppingCart.chekingAvailability')"
      @click="checkAvailability()"
      display="inline-flex"
      alignItems="center"
    >
      <c-icon name="refresh" color="brand.purple" mr="xs" size="1.25rem" />
      <span>{{ $t("shoppingCart.checkAvailability") }}</span>
    </c-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { IOrderRow, IAvailabilityRequest } from "@iloq/shared";
import { CButton, CIcon } from "@chakra-ui/vue";
import { isBundledProduct } from "../../util/ProductUtil";
import { Availability } from "../../store/shoppingCartModule";

export default defineComponent({
  name: "CheckAvailability",
  components: {
    CButton,
    CIcon,
  },
  computed: {
    ...mapState("productSearch", {
      categoryTree: "categoryTree",
    }),
  },
  data() {
    return {
      checkingAvailability: false,
    };
  },
  methods: {
    setAvailabilities(results) {
      this.$store.dispatch("shoppingCart/setAvailabilities", results);
    },
    setCheckingAvailability(value) {
      this.checkingAvailability = value;
      this.$emit("checking-availability", value);
    },
    checkAvailability() {
      if (!this.checkingAvailability) {
        this.setCheckingAvailability(true);
      }
      const cartItems: IOrderRow[] = this.$store.state.shoppingCart.cartRows;
      const availabilityRequest: IAvailabilityRequest = { items: [] };
      const serviceproductIds = this.$store.state.productData.serviceproducts.ids;

      cartItems.forEach((cartItem) => {
        if (
          !serviceproductIds.includes(cartItem.product.id) &&
          !isBundledProduct(cartItem, this.categoryTree)
        ) {
          const productID = cartItem.product.id;
          const productQuantity = cartItem.quantity;
          let requestDate;
          if (this.$store.state.shoppingCart.deliveryDetails.requestedDeliveryDate) {
            requestDate = this.$store.state.shoppingCart.deliveryDetails.requestedDeliveryDate.toISOString();
          } else {
            const date = new Date();
            requestDate = date.toISOString(); //"2021-08-26T18:28:46.493Z"
          }
          availabilityRequest.items.push({
            productId: productID,
            requestedDeliveryDate: requestDate,
            quantity: productQuantity,
          });
        } else {
          cartItem.availability = Availability.NOT_AVAILABLE;
        }
      });

      if (availabilityRequest.items.length) {
        this.$store
          .dispatch("productAvailability/getAvailabilities", availabilityRequest)
          .then((results) => {
            this.setAvailabilities(results);
            this.setCheckingAvailability(false);
          })
          .catch(() => {
            this.$store.commit("showGeneralError", {
              dialogTitle: this.$t("ordering.errorNotification.header"),
              dialogText: this.$t("ordering.errorNotification.availabilityTakingLong"),
            });
            this.setCheckingAvailability(false);
          });
      } else {
        this.setCheckingAvailability(false);
      }
    },
  },
});
</script>
